module.exports = __webpack_public_path__ + "img/swap.5d55d725.svg";